import axios from "axios";
import { ACTIVE_VERSION, BASE_URL } from "./base";
import { resolveErrorMessage } from "./service";
import toast from "react-hot-toast";

const API = axios.create({ baseURL: BASE_URL, withCredentials: true });

API.interceptors.request.use((req) => {
  req.headers.version = ACTIVE_VERSION;
  req.headers.platform = "dashboard";
  return req;
});


const ApiCall = async (type, route, data) => {
  try {
    const apiFunctions = {
      post: API.post,
      get: API.get,
      patch: API.patch,
      delete: API.delete,
      put: API.put,
    };

    let response = await apiFunctions[type](route, data);
    var success = true;
    if (response?.data?.success) {
      return response?.data;
    }
  } catch (error) {
    success = false;
  if(error?.response?.status !== 504) { toast.error(`${await resolveErrorMessage(error)}`);}
    return {
      success,
      error: await resolveErrorMessage(error),
      status: error?.response?.status,
    };
  }
};

export default ApiCall;
